// extracted by mini-css-extract-plugin
module.exports = {"root":"_3774dd","titleContainer":"_b90b23","marginDisabled":"_794731","title":"_516845","subtitle":"_3951b4","text":"_34aa4b"};